import type React from 'react';

export interface ChevronDownIconProps {
	width?: string | number;
	height?: string | number;
	color?: string;
	'aria-label'?: string;
}

const ChevronDownIcon: React.FC<ChevronDownIconProps> = ({
	width = 8,
	height = 5,
	color = 'currentColor',
	'aria-label': ariaLabel = 'Chevron Down Icon',
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 8 5"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-label={ariaLabel}
		style={{ color }}
	>
		<path d="M1 0.5L4 3.5L7 0.5" stroke="currentColor" strokeLinecap="round" />
	</svg>
);

export default ChevronDownIcon;
